exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.hljs {\r\n  display: inline-block;\r\n  padding: 0;\r\n  background: transparent;\r\n  vertical-align: middle\n}\n.d2h-file-header {\r\n  display: none\n}\r\n", "", {"version":3,"sources":["F:/E盘卡易项目/学习/vue-code-diff/src/lib/code-diff/index.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,WAAW;EACX,wBAAwB;EACxB,sBAAsB;CACvB;AACD;EACE,aAAa;CACd","file":"index.vue","sourcesContent":["\n.hljs {\r\n  display: inline-block;\r\n  padding: 0;\r\n  background: transparent;\r\n  vertical-align: middle\n}\n.d2h-file-header {\r\n  display: none\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-08b6ea14","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/lib/code-diff/index.vue
// module id = 442
// module chunks = 1